import React, { useState } from 'react'
import injectSheet from 'react-jss'
import styles from './share-lesson-modal.styles'
import {
  Modal,
  ModalHeader,
  ModalContent,
  ModalFooter
} from 'pobble-components/dist/modal'
import Button from 'pobble-components/dist/button'
import EmailInput from 'pobble-components/dist/email-input'
import { ColorsInfo } from 'pobble-components/dist/email-input/utils'
import FormLabel from 'pobble-components/dist/form-elements/form-label'
import FormTextArea from 'pobble-components/dist/form-elements/form-text-area'
import CharactersCount from 'pobble-components/dist/form-elements/characters-count'
import FormRow from 'pobble-components/dist/form-elements/form-row'
import InfoMessage from './info-message/info-message'
import { useRecaptcha } from 'pobble-components/dist/recaptcha'

const ShareLesson = injectSheet(styles)(
  ({
    classes,
    onSubmit,
    requestClose,
    pending,
    id,
    title,
    disableEmailClassification
  }) => {
    const [selectedEmails, setSelectedEmails] = useState([])
    const [message, setMessage] = useState('')

    const {
      Recaptcha,
      recaptchaProps,
      getReCaptchaToken,
      recaptchaPending
    } = useRecaptcha()

    return (
      <>
        <ModalHeader>Share resource</ModalHeader>
        <ModalContent className={classes.modalContent}>
          <FormRow>
            <FormLabel spaceBetween small>
              To: {!!selectedEmails.length && <ColorsInfo />}
            </FormLabel>
            <EmailInput
              cacheKey="shareResouorceEmailCache"
              className="metrics__share_lesson_input"
              disableEmailClassification={disableEmailClassification}
              selected={selectedEmails}
              onChange={setSelectedEmails}
            />
          </FormRow>
          <FormRow>
            <FormLabel spaceBetween small>
              Message (optional) <CharactersCount value={message} max={400} />
            </FormLabel>
            <FormTextArea
              maxLength={400}
              value={message}
              onChange={e => setMessage(e.target.value)}
            />
          </FormRow>
          <InfoMessage title={title} />
        </ModalContent>
        <ModalFooter alignRight>
          <Button
            pending={recaptchaPending || pending}
            disabled={!selectedEmails.length}
            action={() =>
              getReCaptchaToken(recaptchaToken =>
                onSubmit({
                  emails: selectedEmails,
                  recaptchaToken,
                  message
                }).then(requestClose)
              )
            }
            tall>
            {!pending &&
              !recaptchaPending &&
              `Send ${
                selectedEmails.length > 1 ? `${selectedEmails.length} ` : ''
              }invitation${selectedEmails.length > 1 ? 's' : ''}`}
            {(recaptchaPending || pending) && 'Sending...'}
          </Button>
          <Recaptcha {...recaptchaProps} />
        </ModalFooter>
      </>
    )
  }
)

const ShareLessonModal = ({ requestClose, isOpen, ...props }) => {
  return (
    <Modal isOpen={isOpen} closeButton requestClose={requestClose}>
      <ShareLesson requestClose={requestClose} {...props} />
    </Modal>
  )
}

export default ShareLessonModal
